(function(window, angular, undefined) {
    angular.module('formApp')
        .directive('ageSummary', [function() {
            return {
                restrict: 'EA',
                replace: 'true',
                templateUrl: 'directives/age-summary/templates/age-summary.html',
                link: function($scope, element, attr) {
                    $scope.coverStartDate = attr.coverStartDate !== 'false';
                }
            };
        }]);
})(window, window.angular);